import { useMemo } from 'react'
import { calcSixes } from './ggSixes.js'
import { samplePlayers } from './ggSamplePlayers.js'

// G-Sixes — isolated sandbox. 4 players, partners rotate every 6 holes across
// the three 2v2 pairings. calcSixes ported verbatim from GolfGamesScorecard.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GSixes() {
  const rows = useMemo(() => calcSixes(samplePlayers().slice(0, 4)), [])
  return (
    <div className="card">
      <p className="text-sm text-gray-500 mb-3">Partners rotate every 6 holes: (1·2 v 3·4) → (1·3 v 2·4) → (1·4 v 2·3).</p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Pos', 'Player', 'Wins'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>{rows.map((p, i) => (
          <tr key={p.id}><td style={cell}>{i + 1}</td><td style={cell}>{p.name}</td><td style={cell}><b>{p.wins}</b></td></tr>
        ))}</tbody>
      </table>
    </div>
  )
}
